import { ActionButton } from '@/common/buttons/ActionButton';
import { EntityCommentList } from '@/common/entities/entityComment/EntityCommentList';
import { EntityFileList } from '@/common/entities/entityFile/EntityFileList';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { ValList } from '@/common/val/ValList';
import { McdInvLineList } from '@/sc/entities/mcdInv/McdInvLineList';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useEntityMgr } from '../../../common/entityFramework/entityView/EntityMgrContext';
import { McdInvClaimPymtList } from '../mcdInvClaimPymt/McdInvClaimPymtList';

export const McdInvDetail = () => {

  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'info', label: 'Info', content: <EntityForm /> },
    { id: 'dateTracker', label: 'Date Tracker', content: <EntityForm module="sc" entity="MCD_INV_DATE_TRACKER" entityId={entityObj.mcdInvDateTrackerId} /> },
    { id: 'mcdInvSum', label: 'Summary Lines', content: <McdInvLineList mcdInv={entityObj} isCld={false} /> },
    { id: 'mcdInvCld', label: 'CLD Lines', content: <McdInvLineList mcdInv={entityObj} isCld={true} /> },
    { id: 'validation', label: 'Validations', content: <ValList parentEntity="MCD_INV" parentEntityId={entityObj.id} /> },
    { id: 'mcdInvClaimPymt', label: 'Claims & Payments', content: <McdInvClaimPymtList mcdInvId={entityObj.id} /> },
    { id: 'entityFile', label: 'Files', content: <EntityFileList parentEntity="MCD_INV" parentEntityId={entityObj.id} /> },
    { id: 'entityComment', label: 'Comments', content: <EntityCommentList parentEntity="MCD_INV" parentEntityId={entityObj.id} /> }
  ];

  const lifecycleData = {
    title: 'MCD Inv Lifecycle',
    entity: 'MCD_INV',
    entityId: entityObj.id,
    pluginCode: 'MCD_INV_PROC_MGR_ACTION_PLUGIN'
  }

  const deleteCldData = {
    title: 'Delete CLD',
    entity: 'MCD_INV',
    entityId: entityObj.id,
    pluginCode: 'MCD_INV_DELETE_CLD_ACTION_PLUGIN'
  }

  const augButtons = (buttons) => {
    buttons.push(<ActionButton data={lifecycleData} toolTip="Run Lifecycle" icon={fas.faPlay} />);

    // TODO Sanity Check Banner: Please contact Kernel Support
    // TODO A single button that enables a user to either delete or progress an Invoice's CLD from CHECK_FAIL
    if (['READY', 'CONVERTED', 'SUBMITTED', 'SCRUBBED', 'CHECK_FAIL', 'CHECKED'].includes(entityObj.cldStatus)) {
      buttons.push(<ActionButton data={deleteCldData} toolTip="Delete CLD" icon={fas.faCircleXmark} />);
    }
  }

  return (
    <EntityDetail tabSpecs={tabSpecs} augButtons={augButtons} />
  )
}